.lookupField {
  box-sizing: border-box;
  display: inline-block;
  margin-right: 1rem;
  max-width: 85%;
  padding: 0.5rem;
  width: 85%;
}

.error {
  color: #b3261e;
}

.hero {
  margin-top: 6rem;
  text-align: center;
}

.logoWrapper {
  margin-top: 2rem;
}

.buttonRow {
  margin-top: 1rem;
}

.banner {
  background: #f4f2ff;
  box-shadow: 0 10px 75px #212;
  margin: 0;
  padding: 0.5rem;
  text-align: center;
}
